/* ============================================================
   Product Main JS (product-main.liquid)
   Gallery, variants, quantity, add-to-cart, description tabs
   ============================================================ */
(function () {
  "use strict";

  /* ---- Product gallery – thumbnail click + arrow nav ---- */
  const mainImg = qs(".js-gallery-main");
  if (mainImg) {
    const thumbs = Array.from(qsa(".js-gallery-thumb"));
    let currentIndex = 0;

    function goToIndex(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      currentIndex = idx;
      const thumb = thumbs[idx];
      mainImg.src = thumb.dataset.src;
      mainImg.srcset = thumb.dataset.srcset || "";
      thumbs.forEach((t) =>
        t.classList.remove("product-gallery__thumb--active"),
      );
      thumb.classList.add("product-gallery__thumb--active");
      thumb.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        goToIndex(parseInt(thumb.dataset.index, 10));
      });
    });

    const prevBtn = qs(".js-gallery-prev");
    const nextBtn = qs(".js-gallery-next");
    if (prevBtn)
      prevBtn.addEventListener("click", () => goToIndex(currentIndex - 1));
    if (nextBtn)
      nextBtn.addEventListener("click", () => goToIndex(currentIndex + 1));
  }

  /* ---- Variant selector – update price & id ---- */
  const productForm = qs("#ProductForm");
  if (productForm) {
    const idInput = productForm.querySelector('input[name="id"]');
    const bitrixProductInput = productForm.querySelector(
      'input[name="properties[_bitrix_product_id]"]',
    );
    const priceBox = qs("#ProductPrice");
    const radios = qsa(".js-variant-radio", productForm);

    const variantsData = JSON.parse(
      document.getElementById("ProductVariantsJSON")?.textContent || "[]",
    );
    const variantBitrixIds = JSON.parse(
      document.getElementById("ProductVariantBitrixIdsJSON")?.textContent ||
        "{}",
    );
    const deliveryInterest = qs(".js-delivery-interest");

    function formatMoney(cents) {
      const amount = cents / 100;
      const str = Number.isInteger(amount)
        ? amount.toString()
        : amount.toFixed(2);
      return str + " AED";
    }

    function updateVariant() {
      const selectedOptions = [];
      qsa("fieldset.product-option", productForm).forEach((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value);
      });

      const variant = variantsData.find((v) =>
        selectedOptions.every((opt, i) => v["option" + (i + 1)] === opt),
      );

      if (idInput && variant) idInput.value = variant.id;
      if (bitrixProductInput && variant)
        bitrixProductInput.value = variantBitrixIds[String(variant.id)] || "";

      if (priceBox && variant) {
        const price = formatMoney(variant.price);
        const compare = variant.compare_at_price
          ? formatMoney(variant.compare_at_price)
          : null;
        let html = "";
        if (compare)
          html += `<span class="product-info__price-compare">${compare}</span>`;
        html += `<span class="product-info__price-current">${price}</span>`;
        if (compare)
          html += `<span class="product-info__price-badge">SALE</span>`;
        priceBox.innerHTML = html;
      }

      const skuEl = qs(".product-info__sku");
      if (skuEl && variant?.sku) skuEl.textContent = "SKU: " + variant.sku;

      const atcBtn = productForm.querySelector(".js-atc");
      if (atcBtn && variant) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? "BUY" : "Sold Out";
      }

      if (deliveryInterest && variant) {
        deliveryInterest.dataset.variantTitle = variant.title || "";
        deliveryInterest.dataset.variantId = variant.id || "";
        deliveryInterest.dataset.sku = variant.sku || "";
      }

      const wlBtn = productForm
        .closest(".product-info")
        ?.querySelector(".js-wishlist-toggle");
      if (wlBtn && variant) {
        wlBtn.dataset.productVariant = variant.option1 || "";
        wlBtn.dataset.productSku = variant.sku || "";
        wlBtn.dataset.productPrice = formatMoney(variant.price);
      }

      qsa(".product-option__item", productForm).forEach((label) => {
        const input = label.querySelector("input");
        label.classList.toggle(
          "product-option__item--selected",
          input?.checked || false,
        );
      });
    }

    radios.forEach((r) => r.addEventListener("change", updateVariant));

    /* ---- Add to cart – fetch API (ajax) ---- */
    const atcBtn = qs(".js-atc");
    if (atcBtn) {
      productForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        atcBtn.disabled = true;
        atcBtn.textContent = "Adding…";

        try {
          const data = new FormData(productForm);
          const res = await fetch(window.theme.routes.cartAdd + ".js", {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            body: data,
          });
          if (!res.ok) throw new Error("Cart add failed");
          await res.json();

          atcBtn.textContent = "Added ✓";
          const cartRes = await fetch(window.theme.routes.cart + ".js");
          const cartData = await cartRes.json();
          const countEl = qs(".js-cart-count");
          if (countEl) {
            countEl.textContent = cartData.item_count;
            countEl.style.display = cartData.item_count > 0 ? "" : "none";
          }
        } catch {
          atcBtn.textContent = "Error – try again";
        } finally {
          setTimeout(() => {
            atcBtn.disabled = false;
            atcBtn.textContent = "BUY";
          }, 2500);
        }
      });
    }

    const deliveryInterestSubmit = qs(".js-delivery-interest-submit");
    if (deliveryInterestSubmit && deliveryInterest) {
      function setDeliveryStatus(status, message, type) {
        if (!status) return;
        status.textContent = message;
        status.classList.remove("is-error", "is-success", "is-info");
        if (type) status.classList.add(`is-${type}`);
      }

      deliveryInterestSubmit.addEventListener("click", async () => {
        const status = deliveryInterest.querySelector(
          ".js-delivery-interest-status",
        );
        const endpoint = deliveryInterest.dataset.endpoint || "";
        const emailInput = deliveryInterest.querySelector(
          ".js-delivery-interest-email",
        );
        const email = emailInput?.value.trim() || "";
        const address =
          deliveryInterest
            .querySelector(".js-delivery-interest-address")
            ?.value.trim() || "";

        if (!endpoint) {
          setDeliveryStatus(
            status,
            "Delivery request form is not configured yet. Please contact us directly.",
            "error",
          );
          return;
        }

        if (emailInput && !emailInput.checkValidity()) {
          setDeliveryStatus(
            status,
            "Please enter a valid email so we can contact you.",
            "error",
          );
          emailInput.reportValidity();
          return;
        }

        const payload = {
          name:
            deliveryInterest
              .querySelector(".js-delivery-interest-name")
              ?.value.trim() || "",
          email,
          country: deliveryInterest.dataset.countryName || "",
          countryCode: deliveryInterest.dataset.countryCode || "",
          address,
          message: address,
          productTitle:
            deliveryInterest.dataset.productTitle ||
            document
              .querySelector(".product-info__title")
              ?.textContent.trim() ||
            "",
          productId: deliveryInterest.dataset.productId || "",
          productUrl:
            deliveryInterest.dataset.productUrl || window.location.href,
          pageUrl: window.location.href,
          variantTitle: deliveryInterest.dataset.variantTitle || "",
          variantId: deliveryInterest.dataset.variantId || "",
          sku: deliveryInterest.dataset.sku || "",
        };

        deliveryInterestSubmit.disabled = true;
        setDeliveryStatus(status, "Sending…", "info");

        try {
          const res = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
          const json = await res.json().catch(() => ({}));

          if (!res.ok || json.ok === false) {
            throw new Error(json.error || "Delivery request failed");
          }

          setDeliveryStatus(
            status,
            "Thanks! Our sales manager will contact you about delivery.",
            "success",
          );
        } catch (error) {
          setDeliveryStatus(
            status,
            error.message || "Could not send request. Please try again.",
            "error",
          );
        } finally {
          deliveryInterestSubmit.disabled = false;
        }
      });
    }
  }

  /* ---- Quantity selectors ---- */
  document.querySelectorAll(".js-qty-minus").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn.nextElementSibling;
      if (input && +input.value > +input.min) input.value = +input.value - 1;
    });
  });
  document.querySelectorAll(".js-qty-plus").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn.previousElementSibling;
      if (input) input.value = +input.value + 1;
    });
  });
})();
